<template>
  <div class="videosecurity">
    <!-- 视频安防-->
    <div class="con">
      <floorTree @checkItem="checkItem2"></floorTree>
      <div class="right-con">
        <div class="right-top">
          <el-input v-model="filterText" placeholder="输入设备名称、设备ID" style="width:360px"></el-input>
          <div class="three-tip">
            <div class="tip-item">
              <span>正常</span>
              <img src="../../../public/static/image/elTree/zhengchangx.png" alt="">
            </div>
            <div class="tip-item">
              <span class="baojing">报警</span>
              <img src="../../../public/static/image/elTree/baojingx.png" alt="">
            </div>
            <div class="tip-item">
              <span class="lixian">离线</span>
              <img src="../../../public/static/image/elTree/lixianx.png" alt="">
            </div>
          </div>
        </div>
        <div class="mynum">
          <div class="num-item">
            <div class="fex-con">
              <p>283</p>
              <span>摄像机总数</span>
            </div>
          </div>
          <div class="num-item">
            <div class="fex-con">
              <p>280</p>
              <span>在线数</span>
            </div>
          </div>
          <div class="num-item">
            <div class="fex-con">
              <p>2</p>
              <span>离线数</span>
            </div>
          </div>
          <div class="num-item">
            <div class="fex-con teshuss">
              <p>1</p>
              <span>异常数</span>
            </div>
          </div>

        </div>

        <div class="jiankong-img">
          <img src="../../../public/static/image/elTree/图纸.png" alt="" class="daimg">
          <div class="zheng-img">
            <!-- <el-popover
                        placement="right"
                        width="240"
                        trigger="click">
                        <div class="jiankong-con">
                             
                        </div>
                        <img src="../../../public/static/image/elTree/bigi.png" alt="" slot="reference">
                        </el-popover> -->
            <img src="../../../public/static/image/elTree/bigi.png" alt="" slot="reference"
              @click="jiankongShow = !jiankongShow">
            <div class="jiankong-con" v-show="jiankongShow">
              <div class="mytop">1层南区摄像头</div>
              <div class="jut-item">
                <span>设备类型：</span>
                <p>DIY-Aprow</p>
              </div>
              <div class="jut-item">
                <span>设备ID：</span>
                <p>B01_F02_003</p>
              </div>
              <div class="jut-item">
                <span>摄像机类型：</span>
                <p>球机</p>
              </div>
              <div class="jut-item">
                <span>运行状态：</span>
                <p>正常</p>
              </div>
              <div class="shishihua">
                <p>实时画面：</p>
                <div>
                  <img src="../../../public/static/image/elTree/放大图片.png" alt="" class="fangda"
                    @click="dialogVisible = true">
                  <img src="../../../public/static/image/elTree/jiankong.jpg" alt="" class="huamian">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog v-dialogDrag :visible.sync="dialogVisible" :close-on-click-modal='false' :show-close='false'
        width="840px">
        <div class="cropper-content">
          <div class="searched">
            <div class="searched-con">
              <span class="timed">选择时间：</span>
              <el-date-picker v-model="value2" style="width:360px" type="datetimerange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>

              <div class="xiazaibtn">
                下载<img class="imged" src="../appPage/img/9.png">
              </div>
            </div>
            <div class="gianbi" @click="dialogVisible = false">
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </div>
          </div>
          <div class="cropper">
            <!-- <img src="./img/211.jpg"> -->
            <video controls width="100%" height="437px" style=" background: #000;" src="../../../public/static/image/elTree/huiyi.mp4"></video>
          </div>
        </div>

      </el-dialog>
    </div>
  </div>
</template>

<script>
  import floorTree from '@/components/module/tree/floorTree.vue'
  export default {

    components: {
      floorTree
    },
    data () {
      return {
        filterText: "",
        dataList: [
          {
            'children': [
              {
                'children': [],
                'no': 2,
                'label': "1楼",
                'entityName': "louyu"
              }
            ],
            'no': 1,
            'label': "A栋",
            'entityName': "AppClassType"
          }
        ],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        jiankongShow: false,
        value2: [],
        dialogVisible: false,

      };
    },

    mounted () {

    },
    watch: {

      filterText (val) {
        this.$refs.tree.filter(val);
      },

    },

    methods: {
      checkItem2 (data) {
        console.log(data);

      },
      filterNode (value,data) {
        if(!value) return true;
        return data.label.indexOf(value)!==-1;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .videosecurity {
    background: #e6eef5;

    .con {
      width: 100%;
      height: 100%;
      padding: 8px 8px 12px 8px;
      box-sizing: border-box;
      display: flex;

      /deep/.el-input__inner {
        height: 32px;
      }

      .left-tree {
        width: 225px;
        height: 100%;
        background-color: #fff;
        padding: 20px 12px;
        box-sizing: border-box;
        margin-right: 8px;

        .top-search {
          width: 100%;
          height: 32px;
          margin-bottom: 12px;

        }

        /deep/.el-tree-node__content {
          height: 34px;
        }

        .left-title {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-right: 8px;

          .shuoming {
            margin-right: 8px;
          }

          p {
            font-size: 14px;
            color: #1A1A1A;
          }

          span {
            color: #666666;
            font-size: 12px;
          }

          .kaiqi {
            color: #0D75D4;
          }
        }

        .custom-tree-node {
          width: 100%;
          height: 34px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .left-name {
            height: 34px;
            display: flex;
            align-items: center;
          }

          .shuoming {
            margin-right: 4px;
          }

          p {
            font-size: 14px;
            color: #1A1A1A;
          }

          span {
            color: #666666;
            font-size: 12px;
          }

          .kaiqi {
            color: #0D75D4;
          }

          img {
            margin-right: 4px;
          }
        }

      }

      .right-con {
        width: calc(100% - 233px);
        height: 100%;
        background-color: #fff;
        padding: 20px;
        box-sizing: border-box;

        .right-top {
          width: 100%;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .three-tip {
            display: flex;

            .tip-item {
              margin-left: 20px;
              display: flex;
              align-items: center;

              img {
                width: 20px;
                height: 20px;
                margin-left: 6px;
              }

              span {
                font-size: 13px;
                color: #0085FF;
              }

              .baojing {
                color: #FF2300;
              }

              .lixian {
                color: #666666;
              }

            }
          }
        }

        .mynum {
          width: 100%;
          height: 66px;
          margin: 20px 0px;
          border: 1px solid #EBEBEB;
          border-radius: 4px;
          box-sizing: border-box;
          display: flex;

          .num-item {
            width: 25%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .fex-con {
              text-align: center;
              width: 100%;
              border-right: 1px solid #EBEBEB;

              p {
                font-size: 18px;
                font-weight: bold;
                color: #1A1A1A;
              }

              span {
                font-size: 12px;
                color: #666666;
              }
            }

            .teshuss {
              border-right: 1px solid transparent;
            }
          }
        }

        .jiankong-img {
          width: 100%;
          height: calc(100% - 140px);
          position: relative;

          .daimg {
            width: 100%;
            height: 100%;
          }

          .zheng-img {
            //  width: 36px;
            //  height: 36px;
            position: absolute;
            top: 19%;
            left: 11%;

            img {
              width: 36px;
              height: 36px;
            }
          }

        }

        .jiankong-con {
          position: absolute;
          top: 0px;
          left: 42px;
          width: 265px;
          height: 326px;
          background-color: #fff;
          border-radius: 4px;
          background: #FAFAFA;
          border: 1px solid #E6E6E6;
          box-shadow: 0px 4px 12px 0px #00000033;
          box-sizing: border-box;
          overflow: hidden;

          .mytop {
            width: 100%;
            height: 34px;
            line-height: 34px;
            padding-left: 12px;
            color: #fff;
            font-size: 14px;
            box-sizing: border-box;
            background-color: #368ED9;

          }

          .jut-item {
            display: flex;
            margin-left: 12px;
            margin-top: 12px;
            display: flex;
            width: 100%;
            height: 18px;
            align-items: center;

            span {
              font-size: 12px;
              color: #666666;
              display: inline-block;
              height: 100%;
            }

            p {
              font-size: 12px;
              height: 100%;
              color: #1A1A1A;
            }
          }

          .shishihua {
            margin-left: 12px;
            margin-top: 12px;

            p {
              font-size: 12px;
              color: #666666;
            }

            div {
              width: calc(100% - 12px);
              height: 130px;
              position: relative;

              .huamian {
                width: 100%;
                height: 100%;
              }

              .fangda {
                width: 24px;
                height: 24px;
                position: absolute;
                top: 10px;
                right: 10px;
              }
            }
          }
        }
      }
    }

    /deep/.el-dialog__header {
      //  display: none;
      padding: 20px 0px 0px 0px;
    }

    /deep/.el-dialog__body {
      padding: 0px 20px 20px 20px;
    }

    .searched {
      width: 100%;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .searched-con {
        display: flex;
        align-items: center;
      }

      .xiazaibtn {
        width: 80px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #0085FF;
        font-size: 14px;
        border-radius: 4px;
        color: #fff;
        margin-left: 12px;

        img {
          margin-left: 8px;
        }
      }

      /deep/.el-input__inner {
        height: 36px;
      }

      /deep/.el-input__icon {
        line-height: 28px;
      }

      /deep/.el-date-editor .el-range-separator {
        line-height: 28px;
      }

      .gianbi i {
        cursor: pointer;
        font-size: 20px !important;
      }
    }
  }
</style>